import React from "react";
import { Dialog, DialogProps, CircularProgress, Box } from "@mui/material";

export interface AwaitableDialogProps extends DialogProps {
    isLoading: boolean;
}

export const AwaitableDialog = ({
    children,
    isLoading,
    fullWidth = isLoading,
    ...props
}: AwaitableDialogProps) => {
    return (
        <Dialog {...props} fullWidth>
            {isLoading ? (
                <Box
                    height="25vh"
                    width="100%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress />
                </Box>
            ) : (
                children
            )}
        </Dialog>
    );
};
